import React, { use, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import FirebaseAuth from "../../backend/firebaseAuth";
import { useAuth } from "../../backend/authContext";
import "./style.css";

const Login = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (user) {
      navigate('/');
    }
  }, [user, navigate]);

  return (
    <div className="login-container">
      <h2 className="login-title">Sign In</h2>
      <FirebaseAuth />
    </div>
  );
};

export { Login };
